import axios from "axios";
import Vue from "vue";
import Vuex from "vuex";
import { Message } from "element-ui";

const socialHub = {
  state: () => ({
    items: [],
    type: null,
    filter: {
      skip: 0,
      take: 20,
      searchTerm: null,
      ids: [],
      sessionIds: [],
      subjectIds: [],
      status: null,
      type: null,
      isDraft: false,
      mentionId: null,
      socialHubPostSortingType: 0,
      hasTopic: null
    },
    newPost: [],
    identifier: +new Date()
  }),
  actions: {
    async getQuestionObjects(store, payload) {
      var res = await axios.post("/Registration/GetQuestions", payload);
      if (res.data.hasError) {
        Message.error(res.data.message);
      }
      return res;
    },
    async attendPostPoll(store, payload) {
      var res = await axios.post("/SocialHub/Attend", payload);
      if (res.status == 200) {
        if (res.data.hasError) {
          Message.error(res.data.message);
        } else {
          Message.success(res.data.message);
        }
      }
      return res;
    },
    async deletePost(store, payload) {
      var res = await axios.post("SocialHub/Delete", { id: payload });
      if (res.data.hasError) {
        Message.error(res.data.message);
      } else {
        Message.success(res.data.message);
      }
      return res;
    },
    async deleteComment(store, payload) {
      var res = await axios.post("SocialHub/DeleteComment", { id: payload });
      if (res.data.hasError) {
        Message.error(res.data.message);
      } else {
        Message.success(res.data.message);
      }
      return res;
    },
    async getSocialHubList(store, payload) {
      var res = await axios.post("SocialHub/List", payload);
      if (res.data.hasError) {
        Message.error(res.data.message);
      } else {
        store.commit("setPosts", res.data.data.items);
      }
      return res;
    },
    async toggleLikeComment(store, payload) {
      var res = await axios.post("socialhub/togglelikecomment", payload);
      return res;
    }
  },
  mutations: {
    deletePost(state,payload){
      state.items = state.items.filter(x => x.id != payload);
    },
    setNewPost(state, payload) {
      state.newPost.push(payload);
    },
    resetNewPost(state) {
      state.newPost = [];
    },
    resetPosts(state) {
      state.items = [];
    },
    setPosts(state, payload) {
      payload = payload.map(x => {
        return {
          ...x,
          postComments: []
        };
      });
      state.items.push(...payload);
    },
    changeSocialItemType(state, payload) {
      state.filter.type = payload;
    },
    changeSocialItemTopicType(state, payload) {
      state.filter.hasTopic = payload;
    },
    changeSocialItemSortingType(state, payload) {
      state.filter.socialHubPostSortingType = payload;
    }
    // setSocialHubList(state,payload){
    //     state.items = payload.items;
    // },
  },
  getters: {
    getNewPost: state => state.newPost,
    getSocialHubPosts: state => state.items,
    getSocialHubFilter: state => state.filter,
    getSocialHubList: state => state.items,
    getSocialType: state => state.filter.type,
    getSocialTopicType: state => state.filter.hasTopic
  }
};

export default socialHub;



// WEBPACK FOOTER //
// ./src/store/socialModule.js